import { formatBooleanValue } from "../../util";
import AttachmentType from "../model/AttachmentType";

const AttachmentTypeMapper = (item: any) => {
  let attachmentType = AttachmentType(item);
  attachmentType.valid = formatBooleanValue(item.valid);
  attachmentType.anonymisationRequired = formatBooleanValue(
    item.anonymisationRequired
  );
  return attachmentType;
};

export default AttachmentTypeMapper;
